import React from 'react';
export const CollectionsLoading = () => {
    return (React.createElement("div", { className: "animate-pulse flex space-s-4 mt-3 mx-1 px-2" },
        React.createElement("div", { className: "space-y-3 flex-1" },
            React.createElement("div", { className: "h-4 bg-skeleton rounded-full w-3/4" }),
            React.createElement("div", { className: "h-4 bg-skeleton rounded-full w-11/12" }),
            React.createElement("div", { className: "h-4 bg-skeleton rounded-full w-5/6" }),
            React.createElement("div", { className: "h-4 bg-skeleton rounded-full w-4/6" }),
            React.createElement("div", { className: "h-4 bg-skeleton rounded-full w-11/12" }),
            React.createElement("div", { className: "h-4 bg-skeleton rounded-full w-5/6" }))));
};
//# sourceMappingURL=CollectionLoading.js.map